(function () {
  // Wait until the page is interactive but not fully loaded
  function initCountryLists() {
    var dataEl = document.getElementById('country-data-json');
    if (!dataEl) return;

    var countries;
    try {
      countries = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    document.querySelectorAll('[data-country-list-lazy]').forEach(function (list) {
      var current = list.dataset.current;

      countries.forEach(function (country) {
        // Skip the current country — already rendered in HTML
        if (country.iso_code === current) return;

        var li = document.createElement('li');
        li.className = 'disclosure-list__item';

        var a = document.createElement('a');
        a.className = 'disclosure-list__option disclosure-option-with-parts';
        a.href = '#';
        a.dataset.value = country.iso_code;
        a.setAttribute('data-disclosure-option', '');

        var part1 = document.createElement('span');
        part1.className = 'disclosure-option-with-parts__part';
        part1.textContent = country.name;

        var part2 = document.createElement('span');
        part2.className = 'disclosure-option-with-parts__part';
        part2.textContent = '(' + country.currency_code + '\u00a0' + country.currency_symbol + ')';

        a.appendChild(part1);
        a.appendChild(part2);
        li.appendChild(a);
        list.appendChild(li);
      });
    });
  }

  // Use requestIdleCallback if available, otherwise defer slightly
  if ('requestIdleCallback' in window) {
    requestIdleCallback(initCountryLists);
  } else {
    setTimeout(initCountryLists, 200);
  }
})();